import { Center, Box as ChakraBox, Divider, HStack, Spinner, Text } from "@chakra-ui/react";
import { Dash } from "components";

export function Item({ label, value, helper, ...props }){
    return(
    <Box {...props}>
        <Text children={<Dash children={value} />} fontSize="1.5rem" fontWeight="bold" />
        { label && <Text fontSize="sm" children={label} />}
        { helper && <Text fontSize="xs" color="GrayText" children={helper} mt={1} />}
    </Box>
    )
}

export function ListItem({ label, value }){
    return(
        <HStack alignItems="center" justifyContent="space-between">
            <Text fontSize="small" children={label} />
            <Divider w="30%" />
            <Text fontSize="small" fontWeight="bold" children={value} />
        </HStack>
    )
}

export function Box({ w = "100%", bgColor = 'rgba(0,0,0,0.08)', textAlign = 'left', p = 6, borderRadius = 6, children, title, loading, helper, ...props }){

    return (
    <ChakraBox w={w} bgColor={bgColor} textAlign={textAlign} p={p} borderRadius={borderRadius} {...props}>
        { title && <Text fontWeight="bold" fontSize="sm" children={title} mb={6} />}
        { loading ? <Center py={8}><Spinner /></Center> : children }
        { helper && <Text fontSize="xs" color="GrayText" children={helper} mt={6} />}
    </ChakraBox>
    )
}
